module.exports = __webpack_public_path__ + "img/ic_64_feature_live.4cca09e3.svg";